import useEditableTableDateCell from "../../hooks/useEditableTableDateCell";
import React, {useRef, useState} from "react";
import axios from "axios";
import { createSetDataFreshAction } from "../../actions/dataActions";
import useSafeSave from "../../hooks/useSafeSave";
import { useDispatch, useSelector } from "react-redux";
import {getDataFresh} from "../../state/selectors";
import PrintJob from "./PrintJob";
import {useReactToPrint} from "react-to-print";
import { Button, Checkbox, Control, Field, Select, TextArea } from "@allxsmith/bestax-bulma";
import FitterSelector from "./FitterSelector";
import {getStatus, fixEmptyDates, readableDate, formatDate} from "../../utils";
import  {ToastContainer, toast} from "react-toastify";
import useEditableTableTextCell from "../../hooks/useEditableTableTextCell";

function JobRow({ job, endpoint, onJobUpdate, index, showApprover, fitters, showWash, showStatusChange }) {
  const componentRef = useRef();

  const handlePrint = useReactToPrint({contentRef: componentRef})
  const dateFields = ["book_in_date", "workshop_date", "finish_date"];
  const [editable, setEditable] = useState(false);
  const [lastEdited, setLastEdited] = useState();
  let dataFresh = useSelector(getDataFresh);
  const dispatch = useDispatch();

  const {status, approved} = getStatus(job, "Job");

  const submitUpdate = () => {
    const url = endpoint + "joblistsave/" + job.id;
    const data = fixEmptyDates(job, dateFields);
    const conf = {
      method: "put",
      data,
      url
    };

    return axios(conf).then(() => {
      setEditable(false);
      dispatch(createSetDataFreshAction(dataFresh + 1));
    });
  };

  const onSave = e => {
    return submitUpdate();
  };

  const checkUpdated = () => {
    return axios.get(endpoint + "jobs/" + job.id).then(newJob => {
      return newJob.data.last_saved === job.last_saved;
    });
  };

  const [makeDirty, safeSave] = useSafeSave(
    onSave,
    lastEdited,
    undefined,
    checkUpdated
  );

  const onChange = e => {
    makeDirty();
    setLastEdited(new Date());
    let newJob = { ...job };
    newJob[e.target.name] = e.target.value;
    onJobUpdate(index, newJob);
  };

  const onCheck = e => {
    onChange({target: {name: e.target.name, value: !job[e.target.name]}});
  };

  const statusChange = (status) => {
    let newJob = job;
    const url = endpoint + "jobs/returned/" + job.id;
    newJob.status = status;

    axios.put(url, newJob).then(response => {
      dispatch(createSetDataFreshAction(dataFresh + 1))
    }).catch(reason => {
      toast.error("An error occurred!",  {position: "top-right"})
    });
  }


  const triggerFitterChange = data => {
    makeDirty();
    setLastEdited(new Date());
    let newJob = {...job};
    newJob['fitter'] = data.fitter;
    onJobUpdate(index, newJob);
  };

  const getColour = () => {
    if(job.should_danger && !job.approved){
      return "table-highlight-dark-red"
    }
    if(job.should_warn && !job.approved){
      return "table-highlight-orange"
    }
    return ""
  }

  return (
    <tr
      className={`clickable small-row-black`}
      onClick={() => window.open(`/editjob/${job.id}`, "_self")}
      key={job.id}
    >
      <td className={getColour()}>{job.id}</td>
      <td className={getColour()}>{job.is_enquiry ? "" : job.vehicle.registration}</td>
      <td className={getColour()}>{job.is_defect ? job.defect_description : job.is_enquiry ? job.enquiry_description : job.work_descriptions}</td>
      <td className={getColour()}>
      <Field className="has-addons">
        <Control>
          <TextArea
            rows={2}
            className="small-row-black min-column-width"
            type="text"
            value={job.comments_list.length > 0 ? readableDate(formatDate(new Date(job.comments_list[job.comments_list.length -1].created))) +"\n"+ job.comments_list[job.comments_list.length -1].text : ""}
            disabled
            readOnly
          />
        </Control>
      </Field>
      </td>
      <td className={getColour()}>
        <Control>
          {job.customer ? job.customer : ""}
          <p>{job.customer_phone}</p>
        </Control>
      </td>
      <td className={getColour()}>
        <Control>
          {job.customer2 ? job.customer2 : ""}
          <p>{job.customer2_phone}</p>
        </Control>
      </td>
      <td onClick={e => e.stopPropagation()} className={getColour()}>
        <FitterSelector
          fitters={fitters}
          value={job.fitter ? job.fitter.id  : ""}
          triggerChange={triggerFitterChange}
          editable={editable}
          setEditable={setEditable}
          onSave={safeSave}
          inlineEdit={!job.is_defect || !job.is_enquiry}
        />
      </td>
      {useEditableTableTextCell({
        propName: "estimated_hours",
        value: job.estimated_hours,
        onChange,
        onSave: safeSave,
        editable,
        setEditable,
        tdClass: getColour(),
        inlineEdit: true
      })}
      <td className={getColour()}>{job.labour_hours}</td>
      <td className={getColour()}>{job.is_enquiry ? "" : job.vehicle.make ? job.vehicle.make : ""}</td>
      <td className={getColour()}>{job.is_enquiry ? "" :job.vehicle.model ? job.vehicle.model : ""}</td>
      <td data-testid={"job-status"+index} className={getColour()}>{status}</td>
      <td className={getColour()}>{job.vehicle ? job.vehicle.key : ""}</td>
      <td onClick={e => e.stopPropagation()} className={job.vehicle_arrived ? "table-highlight-green" : getColour()}>
        <Select
          value={job.vehicle_arrived}
          name={"vehicle_arrived"}
          onChange={onChange}
          disabled={!editable}
          data-testid={"vehicle-arrived"+index}
        >
          <option key={"false"} value={"false"}>No</option>
          <option key={"true"} value={"true"}>Yes</option>
        </Select>
      </td>
      <td onClick={e => e.stopPropagation()} className={getColour()}>
        <Select
          value={job.all_parts_arrived}
          name={"all_parts_arrived"}
          onChange={onChange}
          disabled={true}
          data-testid={"all-parts-arrived"+index}
        >
          <option key={"false"} value={"false"}>No</option>
          <option key={"true"} value={"true"}>Yes</option>
        </Select>
      </td>
      <td onClick={e => e.stopPropagation()} className={getColour()}>
        <Select
          value={job.wash_needed}
          name={"wash_needed"}
          onChange={onChange}
          disabled={!editable}
          data-testid={"wash-needed"+index}
        >
          <option key={"false"} value={"false"}>No</option>
          <option key={"true"} value={"true"}>Yes</option>
        </Select>
      </td>
      {useEditableTableDateCell({
        propName: "date_created",
        value: job.date_created,
        onChange,
        onSave: safeSave,
        editable: false,
        inlineEdit: false,
        tdClass: getColour()
      })}
      {useEditableTableDateCell({
        propName: "workshop_date",
        value: job.workshop_date,
        onChange,
        onSave: safeSave,
        editable,
        setEditable,
        inlineEdit: !job.is_defect || !job.is_enquiry,
        tdClass: getColour()
      })}
      {useEditableTableDateCell({
        propName: "book_in_date",
        value: job.book_in_date,
        onChange,
        onSave: safeSave,
        editable,
        setEditable,
        inlineEdit: !job.is_defect || !job.is_enquiry,
        tdClass: getColour()
      })}
      <td className={getColour()}>
        <Control>
          {job.workshop}
          <p>{job.workshop_phone}</p>
        </Control>
      </td>
      {showApprover &&
        <td className={getColour()}>{job.approving_user ? `${job.approving_user.first_name} ${job.approving_user.last_name}` : ""}</td>
      }
      {showWash &&
      <td onClick={e => e.stopPropagation()} className={getColour()}>
        <Control className={"has-addons"}>
          <Checkbox
            name={"wash_complete"}
            onChange={onCheck}
            checked={job.wash_complete}
            disabled={!editable}
          />
          {editable ? (
                <Control>
                    <Button className={"small-row-white"} color="success" onClick={onSave}>
                        S
                    </Button>
                </Control>
            ) : (
                <Control>
                    <Button
                        onClick={e => {
                            e.stopPropagation()
                            setEditable(!editable)}
                        }
                        className={"small-row-black"}
                    >
                        E
                    </Button>
                </Control>
            )}
        </Control>
      </td>
      }
      {showStatusChange && (
        <td onClick={e => e.stopPropagation()} className={getColour()}>
          <Button
            onClick={() => statusChange("COLLECTED")}
            color={"success"}
          >
            COLLECTED
          </Button>
        </td>
      )
      }
      <td onClick={e => e.stopPropagation()} className={getColour()}>
        <Button
            color="warning"
            disabled={job.is_defect || job.is_enquiry}
            onClick={handlePrint}
        >
          Print
        </Button>
      </td>
      <div style={{ display: "none" }}>
        <div ref={componentRef}>
          <PrintJob data={job}/>
        </div>
      </div>
    </tr>
  );
}

export default JobRow;
